import image1 from "../images/movie1.png"
import image2 from "../images/movie2.png"
import image3 from "../images/movie3.png"
import image4 from "../images/movie4.png"
import image5 from "../images/movie5.png"
import image6 from "../images/movie6.png"
import image7 from "../images/movie7.png"
import image8 from "../images/movie8.png"
import image9 from "../images/movie9.png"
import image10 from "../images/movie10.png"

const allMovies = [
  {
    id: 1,
    image: image1,
    title: "Enola Holmesová 2",
    age: "+13",
    tags: "Vtipný * Napínavý * Rodina",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "komedie"
  },
  {
    id: 2,
    image: image2,
    title: "Enola Holmesová",
    age: "+13",
    tags: "Vtipný * Napínavý * Rodina",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "komedie"
  },
  {
    id: 3,
    image: image3,
    title: "Rocknrolla",
    age: "+16",
    tags: "Gangster * Napínavý * Násilí",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "romantický"
  },
  {
    id: 4,
    image: image4,
    title: "Patriot",
    age: "+16",
    tags: "Gangster * Napínavý * Násilí",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "romantický"
  },
  {
    id: 5,
    image: image5,
    title: "Telefon pana Harrigana",
    age: "+16",
    tags: "Gangster * Napínavý * Násilí",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "akční"
  },
  {
    id: 6,
    image: image6,
    title: "Stážista",
    age: "+16",
    tags: "Rodinný * Napínavý * Romantický",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "akční"
  },
  {
    id: 7,
    image: image7,
    title: "Život",
    age: "+13",
    tags: "Vesmír * Napínavý * Nebezpečí",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "sci-fi"
  },
  {
    id: 8,
    image: image8,
    title: "Kód za miliardu dolarů",
    age: "+13",
    tags: "IT * Napínavý",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "sci-fi"
  },
  {
    id: 9,
    image: image9,
    title: "Pracháči",
    age: "+16",
    tags: "Dokument * Napínavý",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "napínavý"
  },
  {
    id: 10,
    image: image10,
    title: "Whoami",
    age: "+13",
    tags: "Gangster * Napínavý * Násilí",
    description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Autem accusantium amet nemo minus quo architecto quas",
    category: "napínavý"
  },
]


export default allMovies
